import style from './style.module.css';
import { Translate, useTranslate } from '~/i18n';
import Container from '../common/container';
import { publicUrl } from '~/utils/publicUrl';
import Image from 'next/image';
import { isJarir } from '~/utils/theme';

const DigitizeBusiness = () => {
   const { translate, dir } = useTranslate();
   const ticketingValues = [
      {
         icon: (
            <Image src={publicUrl('images/ticketing/cutting-edge.png')} width={214} height={140} />
         ),
         name: translate({ id: 'ticketing:cutting edge technology' }),
      },
      {
         icon: <Image src={publicUrl('images/business/tech.png')} width={160} height={150} />,
         name: translate({ id: 'ticketing:more sales through our network' }),
      },
      {
         icon: <Image src={publicUrl('images/business/increase.png')} width={170} height={160} />,
         name: translate({ id: 'ticketing:comprehensive data dashboards' }),
      },
   ];

   const whyChooseUsList = [
      translate({ id: 'ticketing:why choose 1' }),
      translate({ id: 'ticketing:why choose 2' }),
      translate({ id: 'ticketing:why choose 3' }),
   ];

   const featuresList = [
      translate({ id: 'ticketing:feature 1' }),
      translate({ id: 'ticketing:feature 2' }),
      translate({ id: 'ticketing:feature 3' }),
      translate({ id: 'ticketing:feature 4' }),
      translate({ id: 'ticketing:feature 5' }),
      translate({ id: 'ticketing:feature 6' }),
   ];

   return (
      <div className={`${style['gray-bg']}`}>
         <Container>
            <div className="lg:flex  lg:pt-[109px] lg:pb-[118px] py-10 items-center">
               <div className=" font-semibold lg:w-1/3 text-[30px] lg:text-[50px]  leading-[30px]  lg:leading-[54px] text-center lg:ltr:text-left lg:rtl:text-right">
                  <Translate id="ticketing:a seamless" />
                  <div className="text-[#0552BC]">
                     {' '}
                     <Translate id="ticketing:ticketing experience" />
                  </div>
               </div>
               <div className="lg:grid gap-10 lg:grid-cols-3  ">
                  {ticketingValues.map((value, key) => (
                     <div key={key} className="grid text-center justify-items-center">
                        <div className=" ">{value.icon}</div>
                        <div>
                           <div className=" mb-2 text-[16px] lg:text-[24px] font-semibold leading-8 h-[90px] w-52 sm:w-56 ">
                              {value.name}
                           </div>
                        </div>
                     </div>
                  ))}
               </div>
            </div>
            <hr />
            <Container>
               <div className="lg:grid lg:grid-cols-2 gap-4 flex flex-col items-center pt-[60px] lg:py-[100px] ">
                  <img src="/images/ticketing/hy-tickets.png" />
                  <div className="lg:px-[60px] text-center lg:ltr:text-left lg:rtl:text-right">
                     <div className="py-[20px] text-[28px] lg:text-[45px] font-bold leading-[36px] lg:leading-[51px]">
                        <Translate id="ticketing:why choose our ticketing" />
                     </div>
                     <div className="text-[#495057] text-[16px] lg:text-[24px] leading-[25px] lg:leading-[34px]">
                        <Translate id="ticketing:why choose description" />
                     </div>
                  </div>
               </div>
               <div className="md:grid grid-cols-1 lg:grid-cols-3 gap-6">
                  {whyChooseUsList.map((options, key) => (
                     <div key={key}>
                        <div
                           className="bg-white py-5 px-8 h-[116px] flex items-center rounded-lg text-[#343A40] text-[18px] my-3"
                           style={
                              dir === 'rtl'
                                 ? { borderRight: '8px solid #0552BC' }
                                 : { borderLeft: '8px solid #0552BC' }
                           }>
                           <div className="w-full"> {options}</div>
                        </div>
                     </div>
                  ))}
               </div>
               <div className="lg:grid lg:grid-cols-2 gap-4 flex flex-col items-center pt-[60px] lg:py-[100px] ">
                  <div className="w-11/12 text-center lg:ltr:text-left lg:rtl:text-right">
                     <div className="py-[20px] text-[28px] lg:text-[45px] font-bold leading-[36px] lg:leading-[51px]">
                        <Translate id="ticketing:we have variety of features" />
                     </div>
                  </div>
                  <img className="order-first lg:order-last" src="/images/ticketing/fetaures.png" />
               </div>
               <div className={`md:grid grid-cols-1 lg:grid-cols-3 gap-6 ${isJarir && 'pb-20'}`}>
                  {featuresList.map((feature, key) => (
                     <div key={key}>
                        <div
                           className="bg-white py-5 px-8 h-[116px] flex items-center rounded-lg text-[#343A40] text-[18px] my-3"
                           style={
                              dir === 'rtl'
                                 ? { borderRight: '8px solid #0552BC' }
                                 : { borderLeft: '8px solid #0552BC' }
                           }>
                           <div className="w-full"> {feature}</div>
                        </div>
                     </div>
                  ))}
               </div>
            </Container>
            {!isJarir ? (
               <>
                  <div className="pt-20 text-center">
                     <div className="text-[30px] lg:text-[50px]  leading-[30px]  lg:leading-[54px] font-semibold pb-8">
                        <Translate id="business:what is your business about" />{' '}
                     </div>
                     <Image src="/images/ticketing/digital-tools.png" width="1300" height="690" />
                  </div>
               </>
            ) : null}
         </Container>
      </div>
   );
};
export default DigitizeBusiness;
